module.exports = __webpack_public_path__ + "static/media/hide-password.8aafcedf.png";